export default __webpack_public_path__ + "static/media/cloud.f3dd319f.svg";